// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero[data-v-c0c846e2]{max-width:100vw;overflow-x:hidden}.google-reviews[data-v-c0c846e2]{width:100%;padding:40px 10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
